const userAgent = navigator.userAgent || navigator.vendor || window.opera;

// 获取操作系统
export function getOS() {
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }
  if (/android/i.test(userAgent)) {
    return 'Android';
  }
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }
  if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
    return 'MacOS';
  }
  if (/Win32|Win64|Windows|WOW64/.test(userAgent)) {
    return 'Windows';
  }
  if (/Linux/.test(userAgent)) {
    return 'Linux';
  }
  return 'Unknown';
}

// 获取浏览器类型
export function getBrowserType() {
  if (userAgent.indexOf('Firefox') > -1) {
    return 'Firefox';
  } else if (userAgent.indexOf('Edg') > -1) {
    return 'Microsoft Edge';
  } else if (userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Safari') > -1) {
    return 'Chrome';
  } else if (userAgent.indexOf('Safari') > -1) {
    return 'Safari';
  } else if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) {
    return 'Opera';
  } else if (userAgent.indexOf('Trident') > -1 || userAgent.indexOf('MSIE') > -1) {
    return 'Internet Explorer';
  }
  return 'Unknown';
}

// 获取浏览器版本
export function getBrowserVersion() {
  if (/firefox\/(\d+\.\d+)/i.test(userAgent)) {
    return `Firefox ${RegExp.$1}`;
  }
  if (/edg\/(\d+\.\d+)/i.test(userAgent)) {
    return `Microsoft Edge ${RegExp.$1}`;
  }
  if (/chrome\/(\d+\.\d+)/i.test(userAgent) && !/edg\//i.test(userAgent)) {
    return `Chrome ${RegExp.$1}`;
  }
  if (/safari\/(\d+\.\d+)/i.test(userAgent) && !/chrome|crios/i.test(userAgent)) {
    if (/version\/(\d+\.\d+)/i.test(userAgent)) {
      return `Safari ${RegExp.$1}`;
    }
    return 'Safari (version unknown)';
  }
  if (/opr\/(\d+\.\d+)/i.test(userAgent)) {
    return `Opera ${RegExp.$1}`;
  }
  if (/trident\/7.0.*rv:(\d+\.\d+)/i.test(userAgent)) {
    return `Internet Explorer ${RegExp.$1}`;
  }
  return 'Unknown Browser or Version';
}

// 获取操作系统版本
export function getOSVersion() {
  if (/windows nt 10.0/i.test(userAgent)) {
    return 'Windows 10';
  }
  if (/windows nt 6.3/i.test(userAgent)) {
    return 'Windows 8.1';
  }
  if (/windows nt 6.2/i.test(userAgent)) {
    return 'Windows 8';
  }
  if (/windows nt 6.1/i.test(userAgent)) {
    return 'Windows 7';
  }
  if (/windows nt 6.0/i.test(userAgent)) {
    return 'Windows Vista';
  }
  if (/windows nt 5.1/i.test(userAgent)) {
    return 'Windows XP';
  }
  if (/mac os x (\d+_\d+)/i.test(userAgent)) {
    return `MacOS ${RegExp.$1.replace('_', '.')}`;
  }
  if (/android (\d+\.\d+)/i.test(userAgent)) {
    return `Android ${RegExp.$1}`;
  }
  if (/cpu (?:iphone )?os (\d+_\d+)/i.test(userAgent)) {
    return `iOS ${RegExp.$1.replace('_', '.')}`;
  }
  return 'Unknown OS or Version';
}

// 获取设备类型
export function getDeviceType() {
  if (/mobile/i.test(userAgent)) {
    return 'Mobile';
  }
  if (/tablet|ipad|playbook|silk/i.test(userAgent)) {
    return 'Tablet';
  }
  if (/windows|macintosh|linux/i.test(userAgent)) {
    return 'Desktop';
  }
  return 'Unknown Device';
}

// 获取浏览器语言
export function getBrowserLanguage() {
  return navigator.language || 'Unknown Language';
}

// 获取浏览器国家
export function getBrowserCountry() {
  const language = navigator.language || 'unknown';
  const regionMatch = language.match(/-([A-Z]{2})$/); // 匹配区域代码
  return regionMatch ? regionMatch[1] : 'Unknown Country';
}

// 获取浏览器时区
export function getBrowserTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Unknown Time Zone';
}

// 获取屏幕宽度
export function getScreenWidth() {
  return screen.width;
}

// 获取屏幕高度
export function getScreenHeight() {
  return screen.height;
}

// 获取页面加载时间
export function getPageLoadTime() {
  // 获取导航性能条目
  const [navigationEntry] = window.performance.getEntriesByType('navigation');

  if (navigationEntry) {
    // 计算页面加载时间（单位：毫秒）
    return navigationEntry.loadEventEnd - navigationEntry.startTime;
  } else {
    return 'Not Support Performance Navigation Timing API';
  }
}

// 安全获取信息的工具函数
export const safeGet = (fn) => {
  try {
    return fn() + '';
  } catch (error) {
    console.warn(`Error getting info: ${error.message}`);
    return `Error getting info: ${error}`;
  }
};

/**
 * 格式化引用页面 URL
 * @param {string} url - 原始 URL
 * @returns {string} - 格式化后的完整 URL
 */
function formatReferUrl(url) {
  // 如果 url 为空，直接返回
  if (!url) return 0;
  if (url === '/') return 0;
  // 如果是完整的 URL（以 http:// 或 https://开头），直接返回
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  // 如果只有路径，拼接成完整的 URL
  const baseUrl = window.location.origin;
  return `${baseUrl}${url}`;
}

export function getCommonParams(store, route, i18n) {
  const params = {
    // 页面信息相关参数type=inter
    page_url: window.location.href, // 获取当前页面的完整URL，包含协议、域名和路径
    page_referrer_url: route.from?.path || document.referrer || 0, // 获取页面来源：优先使用 referrer，其次使用路由来源
    page_name: route.to?.meta?.name ? i18n.t(route.to.meta.name) : route.to?.name, // 获取页面名称：优先使用i18n翻译的meta name，其次使用路由名称

    // 用户和商户身份信息
    merchant_no: store.getters.app.userLogin?.merchantNo || '', // 获取商户号，如果不存在则返回空字符串
    user_id: store.getters.app.userLogin?.operatorId || '', // 获取用户ID（操作员ID），如果不存在则返回空字符串
    user_role: store.getters.app.userLogin?.roleName || '', // 获取用户角色，如果不存在则返回空字符串

    // 语言相关信息
    browser_language: navigator.language || navigator.browserLanguage || '', // 获取浏览器语言设置，提供多个兼容选项
    merchant_language: store.getters.app.currentLan || 'en', // 获取商户选择的语言，默认为英语

    // 时间信息
    timestamp: new Date().getTime(), // 生成时间戳，用于记录事件发生时间

    // 设备和浏览器环境信息
    device_type: getDeviceType().toLowerCase(), // 获取并转换设备类型为小写（mobile/tablet/desktop）
    operation_system: getOS(), // 获取操作系统类型
    browser_type: getBrowserType(), // 获取浏览器类型
    operation_system_version: getOSVersion(), // 获取操作系统版本
    browser_version: getBrowserVersion(), // 获取浏览器版本
    device_info: navigator.userAgent, // 获取完整的用户代理字符串，包含设备和浏览器的详细信息

  };

  // 格式化 page_referrer_url
  if (params.page_referrer_url) {
    params.page_referrer_url = formatReferUrl(params.page_referrer_url);
  }

  return params;
}

export function getBaseParams() {
  return {
    // 浏览器信息
    kl: safeGet(() => navigator.userAgent),
    oi: safeGet(() => window.location.host),
    rip: safeGet(() => window.location.search.substring(1)),

    // 系统信息
    ope: safeGet(() => getOS()),
    bta: safeGet(() => getBrowserType()),
    vso: safeGet(() => getOSVersion()),
    biv: safeGet(() => getBrowserVersion()),
    tdq: safeGet(() => getDeviceType()),

    // 地区和语言信息
    lb: safeGet(() => getBrowserLanguage()),
    ch: safeGet(() => getBrowserCountry()),
    gt: safeGet(() => getBrowserTimeZone()),

    // 固定值
    cgt: 'WEB',

    // 屏幕和性能信息
    ws: safeGet(() => getScreenWidth()),
    hs: safeGet(() => getScreenHeight()),
    // plt: safeGet(() => getPageLoadTime()),
    timeStamp: safeGet(() => Date.now()),
  } || {};
}
